import React, { useState, useEffect, useRef, useMemo, useContext } from "react";

import axios from "axios";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import TextInput from "components/Input/TextInput.js";
import IntInput from "components/Input/IntInput.js";
import DateInput from "components/Input/DateInput.js";
import AutocompleteTagsInput from "components/Input/AutocompleteTagsInput.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import UserService from "services/UserService";
import LocalizationAutocomplete from "components/LocalizationAutocomplete/LocalizationAutocomplete";
import { budgetpagetext } from "variables/budget";
import { makeStyles } from "@mui/styles";
import { putBudget, getFiles } from "services/ConfigServices";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import BudgetContext from "context/BudgetContext";
import { NotificationManager } from 'react-notifications';
import Chip from "@mui/material/Chip";
import { amounttaxesdata, energyData } from "variables/lists/budget";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";

import { constrainPoint } from "@fullcalendar/react";

import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import FloatInput from "components/Input/FloatInput";
import VentilationDialog from "./VentilationDialog";
import AddVentilation from "./AddVentilation";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;
const InfoText = styled.div`
font-size: 14px;
font-weight: 500;
margin: 15px;
opacity: 1;
`;
const InfoTextBold = styled.div`
font-size: 14px;
font-weight: 600;
margin: 10px;
opacity: 1;
`;

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles2 = makeStyles(styles);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
    fontFamily: '"Source Sans Pro",sans-serif',

  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  textInput: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
    color: "#000000",
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  inputImage: {
    display: "flex",
    flexDirection: "column",
    margin: "0rem 0rem 0rem",
    color: "#000000",
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
    color: "rgba(0, 0, 0, 0.54)",
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: "12px",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function General(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const budgetContext = useContext(BudgetContext);
  const { budget, setBudget } = budgetContext;

  const budgetupdate = permis.includes("budget_update");

  const [name, setName] = useState(budget.parameters.general.name);
  const [datebegin, setDatebegin] = useState(budget.parameters.general.datebegin);
  const [dateend, setDateend] = useState(budget.parameters.general.dateend);
  const [code, setCode] = useState(budget.parameters.general.code);
  const [energy, setEnergy] = useState(budget.parameters.general.energy);
  const [amount, setAmount] = useState(budget.parameters.general.amount);
  const [amounttaxes, setAmounttaxes] = useState(budget.parameters.general.amounttaxes || 'htva');
  const [perimeter, setPerimeter] = useState(budget.parameters.general.perimeter);
  const [description, setDescription] = useState(budget.parameters.general.description);
  const [associateddocuments, setAssociateddocuments] = useState(budget.parameters.general.associateddocuments || []);
  const [ventilations, setVentilations] = useState(budget.parameters.ventilation?.ventilations || []);
  const [totalventilation, setTotalventilation] = useState('');


  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleCodeChange = (event) => { setCode(event.target.value); };
  const handleEnergyChange = (event) => { setEnergy(event.target.value); };
  const handleDatebeginChange = (event) => { setDatebegin(event.target.value); };
  const handleDateendChange = (event) => { setDateend(event.target.value); };
  const handleAmountChange = (event) => {
    let newventilations = [];
    ventilations.forEach(element => {
      let newelement = { ...element };
      if (element.bypercentage) {
        newelement.amount = event.target.value * (element.amountpercentage / 100);
      }
      else {
        newelement.amountpercentage = event.target.value ? (element.amount / event.target.value) * 100 : 0;
      }
      newventilations.push(newelement);
    });
    setVentilations(newventilations);
    setAmount(event.target.value);
  };
  const handleAmounttaxesChange = (event) => { setAmounttaxes(event.target.value); };
  const handlePerimeterChange = (event) => { setPerimeter(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };

  useEffect(() => {
    let total = 0;
    ventilations.forEach(element => {
      total += Number(element.amountpercentage) || 0;
    });
    setTotalventilation(total);
  }, [amount]);
  useEffect(() => {
    let total = 0;
    ventilations.forEach(element => {
      total += Number(element.amountpercentage) || 0;
    });
    setTotalventilation(total);
  }, []);

  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  useEffect(() => {
    axios
      .get(getFiles(chartIdGroup), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  const handleAssociateddocumentsChange = (newValue) => {
    let newArray = [];
    for (let i = 0; i < newValue.length; i++) {
      newArray.push(newValue[i]);
    }
    setAssociateddocuments(newArray);
  };

  const handleEdit = () => {
    let editedbudget = { ...budget };
    editedbudget.parameters.ventilation = {
      ...editedbudget.parameters.ventilation,
      ventilations,
    };
    editedbudget.parameters.general = {
      ...editedbudget.parameters.general,
      name,
      code,
      energy,
      datebegin,
      dateend,
      amount,
      amounttaxes,
      perimeter,
      description,
      associateddocuments,
    };
    axios
      .put(
        putBudget(budget.id),
        {
          ...editedbudget.parameters
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
          setBudget(editedbudget);
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const classes = useStyles();


  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <TextInput
              inputTitle={budgetpagetext.general.name}
              textInput={name}
              handleTextInputChange={handleNameChange}
              disabled={!budgetupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={budgetpagetext.general.code}
              textInput={code}
              handleTextInputChange={handleCodeChange}
              disabled={!budgetupdate}
            />
          </div>
          <div>
            <CustomSelect
              inputTitle={budgetpagetext.general.energy}
              selectValue={energy}
              handleSelectValueChange={handleEnergyChange}
              data={energyData}
              disabled={!budgetupdate}
            />
          </div>
          <div>
            <DateInput
              inputTitle={budgetpagetext.general.datebegin}
              dateInput={datebegin}
              handleDateInputChange={handleDatebeginChange}
              disabled={!budgetupdate}
            />
          </div>
          <div>
            <DateInput
              inputTitle={budgetpagetext.general.dateend}
              dateInput={dateend}
              handleDateInputChange={handleDateendChange}
              disabled={!budgetupdate}
            />
          </div>
          <div>
            <CustomSelect
              inputTitle={budgetpagetext.general.amounttaxes}
              selectValue={amounttaxes}
              handleSelectValueChange={handleAmounttaxesChange}
              data={amounttaxesdata}
              disabled={!budgetupdate}
            />
          </div>
          <div>
            <FloatInput
              inputTitle={budgetpagetext.general.amount}
              floatInput={amount}
              handleFloatInputChange={handleAmountChange}
              disabled={!budgetupdate}
            />
          </div>
          <div>
            <InfoText>{budgetpagetext.general.totalventilation + ' : ' + new Intl.NumberFormat('fr-FR',{minimumFractionDigits: 0,maximumFractionDigits:2}).format(totalventilation)}</InfoText>
          </div>
          <div>
            <TextInput
              inputTitle={budgetpagetext.general.perimeter}
              textInput={perimeter}
              handleTextInputChange={handlePerimeterChange}
              disabled={!budgetupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={budgetpagetext.general.description}
              textInput={description}
              handleTextInputChange={handleDescriptionChange}
              disabled={!budgetupdate}
            />
          </div>

          <div>
            <AutocompleteInput
              disabled={!budgetupdate}
              inputTitle={budgetpagetext.general.associateddocuments}
              selected={associateddocuments}
              list={gedList}
              handleChange={(_, newValue) =>
                handleAssociateddocumentsChange(newValue)
              }
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip label={option.title} {...getTagProps({ index })} />
                ))
              }
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {budgetupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}

function Ventilation(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const budgetContext = useContext(BudgetContext);
  const { budget, setBudget } = budgetContext;
  const budgetupdate = permis.includes("budget_update");

  const [ventilations, setVentilations] = useState(budget.parameters.ventilation?.ventilations || []);
  const [currentVentilation, setCurrentVentilation] = useState(null);
  const [open, setOpen] = useState(false);

  const [totalventilation, setTotalventilation] = useState('');
  const [missingamount, setMissingamount] = useState('');
  const [calculateVentilation, setCalculateVentilation] = useState(false);

  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { groupInfoListById, setPage } = advancedSearchContext;

  const classes = useStyles();
  const classes2 = useStyles2();

  useEffect(() => {
    let total = 0;
    let totalamount = 0;
    ventilations.forEach(element => {
      total += Number(element.amountpercentage) || 0;
      totalamount += Number(element.amount) || 0;
    });
    setTotalventilation(total);
    setMissingamount(budget.parameters.general.amount - totalamount);
  }, []);
  useEffect(() => {
    console.log(ventilations);
    let total = 0;
    let totalamount = 0;
    ventilations.forEach(element => {
      total += Number(element.amountpercentage) || 0;
      totalamount += Number(element.amount) || 0;
    });
    setTotalventilation(total);
    setMissingamount(budget.parameters.general.amount - totalamount);
  }, [calculateVentilation]);


  const handleEdit = () => {
    let editedbudget = { ...budget };
    editedbudget.parameters.ventilation = {
      ...editedbudget.parameters.ventilation,
      ventilations,
    };
    axios
      .put(
        putBudget(budget.id),
        {
          ...editedbudget.parameters
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
          setBudget(editedbudget);
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  
  };

  const columns = [
    {
      name: budgetpagetext.ventilation.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    {
      name: budgetpagetext.ventilation.groups,
      selector: (row) => row.groups,
      sortable: true,
      cell: (row) => (
        <GroupCell>
          <div>{groupInfoListById["" + row.groups]}</div>
        </GroupCell>
      ),
    },
    {
      name: budgetpagetext.ventilation.amountpercentage,
      selector: (row) => row.amountpercentage,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => new Intl.NumberFormat('fr-FR',{minimumFractionDigits: 0,maximumFractionDigits:2}).format(row.amountpercentage),
    },
    {
      name: budgetpagetext.ventilation.amount,
      selector: (row) => row.amount,
      sortable: true,
      cell: (row) => row.amount,
    },
    {
      name: "Actions",
      sortable: false,
      width: "10rem",
      omit: !budgetupdate,
      cell: (row) => (
        <>
          <div className="actions-right">
            <>
              <Tooltip title="Editer la ventilation">
                <Button
                  onClick={editVentilation(row)}
                  color={"warning"}
                  className={classes2.actionButton}
                >
                  <EditIcon fontSize="large" />
                </Button>
              </Tooltip>
              <Tooltip title="Supprimer la ventilation">
                <CustomDeleteButton
                  deleteTitle={"Suppression du contact"}
                  deleteSubTitle={`Êtes-vous sûr de vouloir supprimer la ventilation ${row.name}?`}
                  handleSupprimer={deleteVentilationFunction(row)}
                />
              </Tooltip>
            </>
          </div>
        </>
      ),
    },
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
    setCalculateVentilation(!calculateVentilation);
  };

  const editVentilation = (row) => async () => {
    let obj = ventilations.find((o) => o.uuid === row.uuid);
    if (obj) {
      setCurrentVentilation(obj);
      handleClickOpen();
    }
  }

  const deleteVentilationFunction = (row) => async () => {
    const indexToRemove = ventilations.findIndex((x) => x.uuid === row.uuid);
    let newventilationlist = [...ventilations];
    newventilationlist.splice(indexToRemove, 1);
    setVentilations(newventilationlist);
    setCalculateVentilation(!calculateVentilation);
  };

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <>
        {budgetupdate ?
          <>
            <UploadButton type="button">
              <AddVentilation ventilations={ventilations} setVentilations={setVentilations} calculateVentilation={calculateVentilation} setCalculateVentilation={setCalculateVentilation}/>
            </UploadButton>
          </> : <></>
        }
      </>
    );
  }, [ventilations]);

  const customTableStyles = {
    header: {
      style: {
        fontSize: "14px",
        fontFamily: '"Source Sans Pro",sans-serif',
        fontWeight: "600",
      },
    },
  };

  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <InfoTextBold>{budgetpagetext.general.totalventilation + ' : ' + new Intl.NumberFormat('fr-FR',{minimumFractionDigits: 0,maximumFractionDigits:2}).format(totalventilation)}</InfoTextBold>
          </div>
          <div>
            <InfoTextBold>{budgetpagetext.general.missingamount + ' : ' + new Intl.NumberFormat('fr-FR',{minimumFractionDigits: 0,maximumFractionDigits:2}).format(missingamount)}</InfoTextBold>
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
            title=""
            customStyles={customTableStyles}
            noDataComponent={<NoData>Aucune ventilation à afficher</NoData>}
            // noHeader={true}
            columns={columns}
            persistTableHead
            pagination
            progressComponent={<LinearProgress />}
            expandableRowDisabled={(row) => row.disabled}
            paginationComponentOptions={{
              noRowsPerPage: false,
              rowsPerPageText: "Lignes par page",
              rangeSeparatorText: "sur",
              selectAllRowsItem: false,
              selectAllRowsItemText: "Selectionner toutes les lignes",
            }}
            defaultPageSize={10}
            data={ventilations}
            paginationTotalRows={ventilations?.length || 0}
            manual={true}
            paginationResetDefaultPage={0}
            actions={subHeaderComponentMemo}
          />
          <Dialog
            onClose={handleEditClose}
            aria-labelledby="edituser-dialog-title"
            fullWidth="true"
            maxWidth="md"
            open={open}
          >
            <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
              Modification de la ventilation
            </CustomDialogTitle>
            <DialogContent dividers>
              <VentilationDialog
                currentVentilation={currentVentilation}
                ventilations={ventilations}
                setVentilations={setVentilations}
                closeModal={handleEditClose}
              />
            </DialogContent>
            <DialogActions></DialogActions>
          </Dialog>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {budgetupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}


export { General, Ventilation };
